import './time-range.scss';

import * as gzTimeRangeDirective from './time-range.directive';

export default angular.module('gazelle.components.timeRange', [
  'angularMoment',
  'rhino.components.organization',
])
  .directive(gzTimeRangeDirective.name, gzTimeRangeDirective.default)
  .name;
